import { flattenJsonApiResponse } from '@/store/utils/converter'
import { GetterNames } from './keys'
import { UnitRoundReportState, FlatUnitRoundReport } from './types'

export const getters = {
  [GetterNames.unitRoundReport]: (state: UnitRoundReportState): FlatUnitRoundReport[] => {
    return state.unitRoundReport.map(flattenJsonApiResponse)
  },
  [GetterNames.chosenOneMonthPeriod]: (state: UnitRoundReportState): string => {
    return state.chosenOneMonthPeriod
  },
  [GetterNames.chosenTwoWeekPeriod]: (state: UnitRoundReportState): string[] => {
    return state.chosenTwoWeekPeriod
  },
  [GetterNames.chosenReportPeriod]: (state: UnitRoundReportState): string => {
    return state.chosenReportPeriod
  },
}
